var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c("PageHeader", {
        attrs: {
          subtitle: "Manage access permission for users across the system.",
        },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Tenants", search: "tenants" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { dark: "", color: "success" },
              on: {
                click: function ($event) {
                  _vm.showAddRole = true
                },
              },
            },
            [
              _c("v-icon", [_vm._v("add")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Button.Add_a_new_tenant")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-item-group",
                {
                  attrs: { mandatory: "", "active-class": "white--text" },
                  model: {
                    value: _vm.filters.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "status", $$v)
                    },
                    expression: "filters.status",
                  },
                },
                [
                  _c(
                    "v-subheader",
                    { staticStyle: { display: "inline", cursor: "default" } },
                    [_vm._v("Show:")]
                  ),
                  _vm._v(" "),
                  _c("v-item", {
                    attrs: { value: "active" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ active, toggle }) {
                          return _c(
                            "v-chip",
                            {
                              staticClass: "chipFilter clickable",
                              attrs: {
                                small: "",
                                color: active ? "primary" : "default",
                                selected: active,
                              },
                              on: { click: toggle },
                            },
                            [
                              _vm._v(
                                "\n            Active tenants ⋅\n            " +
                                  _vm._s(_vm.activeTenants.length) +
                                  "\n          "
                              ),
                            ]
                          )
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-item", {
                    attrs: { value: "archived" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ active, toggle }) {
                          return _c(
                            "v-chip",
                            {
                              staticClass: "chipFilter clickable",
                              attrs: {
                                small: "",
                                color: active ? "primary" : "default",
                                selected: active,
                              },
                              on: { click: toggle },
                            },
                            [
                              _vm._v(
                                "\n            Archived tenants ⋅\n            " +
                                  _vm._s(_vm.archivedTenants.length) +
                                  "\n          "
                              ),
                            ]
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.filteredTenants,
                  pagination: _vm.pagination,
                  search: _vm.search,
                  expand: false,
                  "item-key": "RoleName",
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "tr",
                          {
                            on: {
                              click: function ($event) {
                                props.expanded = !props.expanded
                              },
                            },
                          },
                          [
                            _c("td", [
                              _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.item.RoleName) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              props.item.IsArchived
                                ? _c("div", { staticClass: "caption" }, [
                                    _vm._v(
                                      "Archived on " +
                                        _vm._s(
                                          _vm.formatDate(
                                            props.item.ArchivedDateTime,
                                            _vm.prettyDateTimeFormat
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-right" },
                              [
                                _vm.filters.status != "archived"
                                  ? [
                                      _c(
                                        "SecondaryBtn",
                                        {
                                          attrs: {
                                            small: "",
                                            icon: "settings",
                                            to: {
                                              name: "accessManageEntrance",
                                              params: {
                                                name: props.item.RoleName,
                                                id: props.item.Id,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("Button.Manage")) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "SecondaryBtn",
                                        {
                                          attrs: {
                                            disabled:
                                              props.item.Id ==
                                              _vm.currentTenant.id,
                                            small: "",
                                            icon: "archive",
                                            color: "error",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.confirmArchiveTenant(
                                                props.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("Button.Archive")) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showAddRole,
            callback: function ($$v) {
              _vm.showAddRole = $$v
            },
            expression: "showAddRole",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(_vm.$t("AdministrationAccessManage.addTitleMsg"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.showAddRole = false
                          _vm.loading.addNewRole = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "fullScreenWidth",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pa-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tenant Name",
                                  rules: _vm.nameRules,
                                },
                                model: {
                                  value: _vm.newRoleName,
                                  callback: function ($$v) {
                                    _vm.newRoleName = $$v
                                  },
                                  expression: "newRoleName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            loading: _vm.loading.addNewRole,
                            disabled: !!!_vm.newRoleName,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addNewRole()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }